import { render, staticRenderFns } from "./NewTransactions.vue?vue&type=template&id=4f5f4b2a&scoped=true"
import script from "./NewTransactions.vue?vue&type=script&lang=js"
export * from "./NewTransactions.vue?vue&type=script&lang=js"
import style0 from "./NewTransactions.vue?vue&type=style&index=0&id=4f5f4b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f4b2a",
  null
  
)

export default component.exports